import { render } from "./CollapseButton.vue?vue&type=template&id=342b7e32&scoped=true"
import script from "./CollapseButton.vue?vue&type=script&lang=js"
export * from "./CollapseButton.vue?vue&type=script&lang=js"

import "./CollapseButton.vue?vue&type=style&index=0&id=342b7e32&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342b7e32"]])

export default __exports__